import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Contact.css';
import ContactCard from './ContactCard/contactCard';
import ImageDisplay from './ImageDisplay/imageDisplay';
import ContactForm from './ContactForm/contactForm';

// Import translations
import enTranslations from './en.json';
import deTranslations from './de.json';

const Contact = () => {
    const { t, i18n } = useTranslation();

    // Add translations for this component
    i18n.addResourceBundle('en', 'contact', enTranslations, true, true);
    i18n.addResourceBundle('de', 'contact', deTranslations, true, true);
    const [pageHeight, setPageHeight] = useState('auto');

    useEffect(() => {
        const adjustHeight = () => {
            const width = window.innerWidth;
            const height = window.innerHeight;

            if (width < 768 || height < 576) {
                setPageHeight('auto');
                return;
            }

            const headerHeight = document.querySelector('header')?.offsetHeight || 0;
            const availableHeight = height - headerHeight;
            setPageHeight(`${availableHeight}px`);
        };

        // Adjust the height on initial load and window resize
        adjustHeight();
        window.addEventListener('resize', adjustHeight);

        return () => {
            window.removeEventListener('resize', adjustHeight);
        };
    }, []);

    return (
        <div className="contact-page" style={{ height: pageHeight }}>
            <ImageDisplay />
            <div className="combined-contact-container">
                <div className="contact-info-section">
                    <ContactCard />
                </div>
                <div className="contact-form-section">
                    <ContactForm />
                </div>
            </div>
            <div className="contact-mobile">
                    <ContactCard />
                    <ContactForm />
            </div>
        </div>
    );
};

export default Contact;
